import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from '../common/common-crud.service';
import {ScheduleProfile} from '../../model/tools/schedule-profile';
import {CrystalclearToolsBackUrl} from '../config/crystalclear-tools-back-url';
import {Observable} from 'rxjs';
import {ApiValidation} from '../../model/api/api-validation';
import {ScheduleProperties} from '../../model/tools/schedule-properties';
import {ParentAPIService} from "../parent.api.service";
import {ServiceHealthState} from "../../model/tools/service-health-state";
import {CrystalclearClearingBackUrl} from "../config/crystalclear-clearing-back-url";

@Injectable({
  providedIn: 'root'
})
export class HealthService extends ParentAPIService {

  constructor(http: HttpClient) {
    super(http);
  }

  public getServicesHealth(): Observable<ApiValidation<ServiceHealthState[]>> {
    return this.get(CrystalclearToolsBackUrl.GET_SERVICES_HEALTH);
  }

}
